export default "__VITE_ASSET__DnRnCvw$__"